export default "__VITE_ASSET__f0b461a4__"